module.exports = __webpack_public_path__ + "static/media/logo_himalayan_javahouse_LARGE.e73f7031.png";